exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Status_paid_3USp {\n  margin-left: 5px;\n\n  color: #1c862e;\n}\n", ""]);

// exports
exports.locals = {
	"paid": "Status_paid_3USp"
};